import { colors } from '@kmns-internal/furikake'
import { Stack, Typography } from '@mui/material'
import { HTMLAttributes } from 'react'

type Props = {
  title: string
  caption?: string
  icon?: React.ReactNode
  isPre?: boolean
} & HTMLAttributes<HTMLElement>

/**
 * グローバルナビゲーションのサブメニュー内の個々のアイテム (クリック不可能な要素)
 */
export const SubMenuItem = (props: Props) => {
  const { title, caption, icon, isPre, ...restProps } = props

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      {...restProps}
      sx={{
        py: 1,
        px: 2,
        justifyContent: 'flex-start',
      }}
    >
      {icon}
      <Stack>
        {caption && (
          <Typography variant="caption" sx={{ color: colors.text.primary }}>
            {caption}
          </Typography>
        )}
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: isPre ? 'pre-wrap' : 'normal',
            fontFamily: isPre ? 'monospace' : 'inherit',
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Stack>
  )
}
